import { useMemo } from 'react';

import { HeaderAddButton } from '@Components/Grid/components/header/Actions/AddButton'
import { useGrid } from '@Components/Grid/context';
import { useGlobalAuthStore } from '@Stores/global/auth';

export default function HeaderButtons() {
  const { auth: { isSuperAdmin } } = useGlobalAuthStore()
  const { definitions: { entityNameModule, entityNamePlural, entityName, basePath } } = useGrid()

  const path = useMemo(() => {
    if (basePath) {
      return basePath;
    }
    return `/${entityNameModule}/${entityNamePlural.toLowerCase()}`
  }, [basePath, entityNamePlural, entityNameModule])

  if (!isSuperAdmin) {
    return null
  }

  return <HeaderAddButton to={`${path}/add`}>
    New {entityName}
  </HeaderAddButton>
}
